export default "__VITE_ASSET__d067620a__"